<template>
    <div id="app">
        <div class="pc-box">
            <Header/>
            <Banner/>
            <div class="content">
                <div class="content-left">
                    <router-view/>
                </div>
                <div class="content-right">
                    <ContentR/>
                </div>
            </div>
            <Suspension/>
            <Footer/>
            <Mobile/>
        </div>
    </div>
</template>

<script>
import { Header } from 'shared'
import { Banner } from 'shared'
import ContentR from './views/ContentR'
import Footer from './views/Footer'
import { Suspension } from 'shared'
import { Mobile } from 'shared'

export default {
    components: {
        Header,
        Banner,
        ContentR,
        Footer,
        Suspension,
        Mobile
    },
    created() {
        this.$store.commit('getTaiwan', 'AIT')
        this.$store.dispatch('getBannerZt', 'AI')
        this.$store.dispatch('getBannerArticle', 'AI')
        this.$store.commit('getSubmit', 'AI')
        this.$store.commit('dataColor', {
            bar0: '#ff6200',
            bar1: '#ff8f00',
            line0: '#3d8bf0',
            line1: '#cce2ff'
        })
        this.$store.commit('getType', 4)
    },
}
</script>

<style>
#app .right-box .form .btn:hover {
    color: #fff;
    background-color: #ff6200;
    border-color: #ff6200;
}

.company h2::before,
.content-right .platform li:hover,
.move-searchBox,
.report-con .report-title p,
.report-list li a:hover .report-con,
.tsb a:hover span {
    background: #ff6200;
}

.el-menu--horizontal .el-menu .el-menu-item:hover {
    color: #ff6200 !important;
    background: #eee !important;
}
.el-menu--horizontal .el-menu .el-menu-item:hover span {
    color: #ff6200 !important;
}

.content-left .title {
    border-left: 5px solid #ff6200;
}
.content-left .title h2 span {
    color: #ff6200;
    padding: 0 10px;
}

.content-right .right-title a:hover,
.company-title a:hover,
#app .right-box .form .btn,
.text a:hover span,
.content-left .more a,
.project a:hover p,
.report-list li a:hover .report-title p,
.tsb a:hover p,
.mobile-bottom .current,
.mobile-top .current2,
.mobile-submit i,
.backtop:hover,
.code-box:hover {
    color: #ff6200;
}

@media(max-width: 868px) {
  .banner-right .banner-right-m p {
    background: #ff6200;
  }
}
</style>